import React from 'react';

const header = () => {
    return (
    <div className="main-header">
        <a href="https://www.linkedin.com/in/rojinadeuja/" target="_blank" rel="noopener noreferrer">Linkedin</a>
        <a href="https://github.com/rojinadeuja" target="_blank" rel="noopener noreferrer">Github</a>
    </div> 
    )
}

export default header;